module.exports = __webpack_public_path__ + "static/media/EA-Pin.f0a321ce.png";